import {BehaviorSubject} from 'rxjs';
import {wwData$} from '@px/streams/worker-data';
import {marginStorage} from '@px/storage/margin';

export const allSymbols$ = new BehaviorSubject<boolean>(!marginStorage.readMarginStorage().hideOtherSymbols);

allSymbols$.subscribe((allSymbols) => {
  wwData$.next({type: 'margin-all-symbols', data: allSymbols});
  marginStorage.updateMarginStorage({hideOtherSymbols: !allSymbols});
});
